import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import rem from '../../../utils/rem/rem';

export const StyledDashboardButton = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  height: ${rem(82)};
  width: ${rem(275)};
  padding: ${rem(32)} ${rem(24)};
  background-color: ${({ theme }) => theme.colors.white};
  margin-left: ${rem(24)};
  margin-top: ${rem(16)};
  border-radius: ${rem(10)};
  text-transform: uppercase;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.gray900};
  box-shadow: 3px 3px 4px rgba(0, 0, 0, 0.25);

  &:focus {
    ${({ theme }) => theme.states.focus};
    outline-offset: 3px;
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.blueHover};
    color: ${({ theme }) => theme.colors.blue};
  }
`;
